import React from "react";
import "../styles/marine-parks.scss";
import Layout from './layout';

export default function PageLayout({ children }) {
  return <Layout>{children}</Layout>;
}
